<template>
  <div class="bg-neutral-100 py-14 lg:py-28">
    <div class="container grid-default">
      <Heading
        v-if="data.heading"
        :semantic="isSemantic"
        :level="level"
        class="col-span-6 mb-6 text-xl font-light text-blue lg:col-span-5 lg:mb-14 lg:text-3xl"
      >
        {{ data.heading }}
      </Heading>
      <div
        v-if="data.descriptionText"
        class="col-span-6 mb-6 text-lg text-blue lg:col-start-8 lg:col-end-13 lg:mb-14 lg:text-2xl"
      >
        {{ data.descriptionText }}
      </div>

      <ProductList class="col-span-6 lg:col-span-12" :data="data.product" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SectionProductListRecord } from '~/types/generated'

const props = defineProps({
  data: {
    type: Object as PropType<SectionProductListRecord>,
    default: () => {}
  },
  index: {
    type: Number,
    required: true
  }
})

const { level, isSemantic } = useSectionRules(props.index, !!props.data.heading)
</script>
